import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import numeral from 'numeral'
import get from 'lodash/get'
import set from 'lodash/set'
import { FaRegEdit } from 'react-icons/fa'
import { AiOutlineSave } from 'react-icons/ai'

import * as CONSTANTS from '../../constants'
import { Button } from '../../../buttons'
import { FONTS } from '../../../../constants'
import left_arrow from '../../../../static/images/left-arrow.svg'

import { financialFormatter } from '../../../../lib/utils'

const decimalFormatter = (number, noOfDecimal) => {
  number = numeral(number).value()
  if (isNaN(number) || !isFinite(number)) return "-"
  noOfDecimal = noOfDecimal || 2;
  let formatter = "0,0";
  if (noOfDecimal) formatter += ".";
  Array.from(Array(noOfDecimal)).forEach(() => {
    formatter += "0";
  });
  return number ? numeral(number).format(formatter) : "-"
}
const convert2Number = number => parseFloat(number && number !== "-" ? ((typeof (number) === "string") ? number.replace(/,/g, '') : number) : "0")

export default class IndividualRevenueTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
      && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)) {
      const projectByID = get(nextProps, 'projectByID')
      set(tempState, 'project_license_ratio_minimum', projectByID.project_license_ratio_minimum)
      set(tempState, 'project_license_contract_price', projectByID.project_license_contract_price)
      set(tempState, 'project_hardware_ratio_minimum', projectByID.project_hardware_ratio_minimum)
      set(tempState, 'project_hardware_contract_price', projectByID.project_hardware_contract_price)
      set(tempState, 'project_service_contract_price', projectByID.project_service_contract_price)
      set(tempState, 'project_service_ratio_minimum', projectByID.project_service_ratio_minimum)
      set(tempState, 'project_other_service_ratio_minimum', projectByID.project_other_service_ratio_minimum)
      set(tempState, 'project_other_service_contract_price', projectByID.project_other_service_contract_price)
      set(tempState, 'projectByID', projectByID)
    }
    return tempState
  }

  state = {
    collapse_overall: false,
    project_license_ratio_minimum: 0,
    project_license_contract_price: 0,
    project_hardware_ratio_minimum: 0,
    project_hardware_contract_price: 0,
    project_service_contract_price: 0,
    project_service_ratio_minimum: 0,
    project_other_service_ratio_minimum: 0,
    project_other_service_contract_price: 0,
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
      && JSON.stringify(nextState) === JSON.stringify(this.state)) return false
    return true
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    const activeToggle = get(this.props, 'activeToggle')
    const projectByID = get(this.props, 'projectByID')
    const projectSubmit = get(this.props, 'projectByID.profitSheet')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot') || false
    const presale_snapshot_submit = get(projectSubmit, 'presale_snapshot.snapshot') || false
    const projectType = get(projectByID, 'project_type')
    const rSelected = get(this.props, 'rSelected')
    const $canEdit = get(projectByID, '$can_edit')
    const isPresale = presale_snapshot && rSelected === 1
    let canEdit
    if (presale_snapshot) {
      canEdit = $canEdit && rSelected === 2
    } else {
      canEdit = $canEdit
    }
    const canShow = activeToggle === 2 || activeToggle === 3 || projectType === CONSTANTS.SUPPORT
    const editBreakDown = get(this.props, 'editBreakDown')
    const project_status = get(projectByID, 'project_status')
    // Service
    const total_service_max_revenue = isPresale ? presale_snapshot.$total_service_max_revenue : get(projectByID, '$total_service_max_revenue', '-')
    const total_service_cost = isPresale ? presale_snapshot.$total_service_cost : get(projectByID, '$total_service_cost', '-')
    const total_service_max_gross_profit = isPresale ? presale_snapshot.$total_service_max_gross_profit : get(projectByID, '$total_service_max_gross_profit', '-')
    const total_service_max_gross_profit_ratio = isPresale ? presale_snapshot.$total_service_max_gross_profit_ratio : get(projectByID, '$total_service_max_gross_profit_ratio', '-')
    const total_service_max_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_service_max_gross_profit_mandays_avg : get(projectByID, '$total_service_max_gross_profit_mandays_avg', '-')
    const total_service_max_revenue_mandays_avg = isPresale ? presale_snapshot.$total_service_max_revenue_mandays_avg : get(projectByID, '$total_service_max_revenue_mandays_avg', '-')
    const total_service_min_revenue = isPresale ? presale_snapshot.$total_service_min_revenue : get(projectByID, '$total_service_min_revenue', '-')
    const total_service_min_gross_profit = isPresale ? presale_snapshot.$total_service_min_gross_profit : get(projectByID, '$total_service_min_gross_profit', '-')
    const total_service_min_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_service_min_gross_profit_mandays_avg : get(projectByID, '$total_service_min_gross_profit_mandays_avg', '-')
    const total_service_min_revenue_mandays_avg = isPresale ? presale_snapshot.$total_service_min_revenue_mandays_avg : get(projectByID, '$total_service_min_revenue_mandays_avg', '-')
    const total_service_contract_gross_profit = isPresale ? presale_snapshot.$total_service_contract_gross_profit : get(projectByID, '$total_service_contract_gross_profit', '-')
    const total_service_contract_gross_profit_ratio = isPresale ? presale_snapshot.$total_service_contract_gross_profit_ratio : get(projectByID, '$total_service_contract_gross_profit_ratio', '-')
    const total_service_contract_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_service_contract_gross_profit_mandays_avg : get(projectByID, '$total_service_contract_gross_profit_mandays_avg', '-')
    const total_service_contract_revenue_mandays_avg = isPresale ? presale_snapshot.$total_service_contract_revenue_mandays_avg : get(projectByID, '$total_service_contract_revenue_mandays_avg', '-')
    const total_service_discount_price = isPresale ? presale_snapshot.$total_service_discount_price : get(projectByID, '$total_service_discount_price', '-')
    const total_service_discount_ratio = isPresale ? presale_snapshot.$total_service_discount_ratio : get(projectByID, '$total_service_discount_ratio', '-')
    const total_change_requests_service_cost = isPresale ? presale_snapshot.$total_change_requests_service_cost : get(projectByID, '$total_change_requests_service_cost', '-')
    const total_change_requests_service_price = isPresale ? presale_snapshot.$total_change_requests_service_price : get(projectByID, '$total_change_requests_service_price', '-')
    const total_change_requests_service_gross_profit = isPresale ? presale_snapshot.$total_change_requests_service_gross_profit : get(projectByID, '$total_change_requests_service_gross_profit', '-')
    const total_change_requests_service_gross_profit_ratio = isPresale ? presale_snapshot.$total_change_requests_service_gross_profit_ratio : get(projectByID, '$total_change_requests_service_gross_profit_ratio', '-')
    const total_change_requests_service_man_days = isPresale ? presale_snapshot.$total_change_requests_service_man_days : get(projectByID, '$total_change_requests_service_man_days', '-')
    const total_service_contract_with_cr_price = isPresale ? presale_snapshot.$total_service_contract_with_cr_price : get(projectByID, '$total_service_contract_with_cr_price', '-')
    const total_service_contract_with_cr_gross_profit = isPresale ? presale_snapshot.$total_service_contract_with_cr_gross_profit : get(projectByID, '$total_service_contract_with_cr_gross_profit', '-')
    const total_service_contract_with_cr_gross_profit_ratio = isPresale ? presale_snapshot.$total_service_contract_with_cr_gross_profit_ratio : get(projectByID, '$total_service_contract_with_cr_gross_profit_ratio', '-')
    const total_service_contract_with_cr_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_service_contract_with_cr_gross_profit_mandays_avg : get(projectByID, '$total_service_contract_with_cr_gross_profit_mandays_avg', '-')

    // Service Editable
    const project_service_ratio_minimum = isPresale ? presale_snapshot.project_service_ratio_minimum : get(this.state, 'project_service_ratio_minimum', 0)
    const project_service_contract_price = isPresale ? presale_snapshot.project_service_contract_price : get(this.state, 'project_service_contract_price', 0)

    // Hardware
    const total_hardwares_cost = isPresale ? presale_snapshot.$total_hardwares_cost : get(projectByID, '$total_hardwares_cost', '-')
    const total_hardwares_price = isPresale ? presale_snapshot.$total_hardwares_price : get(projectByID, '$total_hardwares_price', '-')
    const total_change_requests_hardware_price = isPresale ? presale_snapshot.$total_change_requests_hardware_price : get(projectByID, '$total_change_requests_hardware_price', '-')
    const total_change_requests_hardware_cost = isPresale ? presale_snapshot.$total_change_requests_hardware_cost : get(projectByID, '$total_change_requests_hardware_cost', '-')
    const total_change_requests_hardware_gross_profit = isPresale ? presale_snapshot.$total_change_requests_hardware_gross_profit : get(projectByID, '$total_change_requests_hardware_gross_profit', '-')
    const total_change_requests_hardware_gross_profit_ratio = isPresale ? presale_snapshot.$total_change_requests_hardware_gross_profit_ratio : get(projectByID, '$total_change_requests_hardware_gross_profit_ratio', '-')
    const total_contract_hardwares_cost_with_cr = isPresale ? presale_snapshot.$total_contract_hardwares_cost_with_cr : get(projectByID, '$total_contract_hardwares_cost_with_cr', '-')
    const total_contract_hardwares_price_with_cr = isPresale ? presale_snapshot.$total_contract_hardwares_price_with_cr : get(projectByID, '$total_contract_hardwares_price_with_cr', '-')
    const total_max_hardwares_gross_profit = isPresale ? presale_snapshot.$total_max_hardwares_gross_profit : get(projectByID, '$total_max_hardwares_gross_profit', '-')
    const total_max_hardwares_gross_profit_ratio = isPresale ? presale_snapshot.$total_max_hardwares_gross_profit_ratio : get(projectByID, '$total_max_hardwares_gross_profit_ratio', '-')
    const total_min_hardwares_price = isPresale ? presale_snapshot.$total_min_hardwares_price : get(projectByID, '$total_min_hardwares_price', '-')
    const total_min_hardwares_gross_profit = isPresale ? presale_snapshot.$total_min_hardwares_gross_profit : get(projectByID, '$total_min_hardwares_gross_profit', '-')
    const total_hardwares_gross_profit = isPresale ? presale_snapshot.$total_hardwares_gross_profit : get(projectByID, '$total_hardwares_gross_profit', '-')
    const total_hardwares_gross_profit_ratio = isPresale ? presale_snapshot.$total_hardwares_gross_profit_ratio : get(projectByID, '$total_hardwares_gross_profit_ratio', '-')
    const total_contract_hardwares_gross_profit_with_cr = isPresale ? presale_snapshot.$total_contract_hardwares_gross_profit_with_cr : get(projectByID, '$total_contract_hardwares_gross_profit_with_cr', '-')
    const total_contract_hardwares_gross_profit_ratio_with_cr = isPresale ? presale_snapshot.$total_contract_hardwares_gross_profit_ratio_with_cr : get(projectByID, '$total_contract_hardwares_gross_profit_ratio_with_cr', '-')
    const total_hardwares_discount_price = isPresale ? presale_snapshot.$total_hardwares_discount_price : get(projectByID, '$total_hardwares_discount_price', '-')
    const total_hardwares_discount_ratio = isPresale ? presale_snapshot.$total_hardwares_discount_ratio : get(projectByID, '$total_hardwares_discount_ratio', '-')
    // Hardware Editable
    const project_hardware_ratio_minimum = isPresale ? presale_snapshot.project_hardware_ratio_minimum : get(this.state, 'project_hardware_ratio_minimum', 0)
    const project_hardware_contract_price = isPresale ? presale_snapshot.project_hardware_contract_price : get(this.state, 'project_hardware_contract_price', 0)

    // License
    const total_licenses_cost = isPresale ? presale_snapshot.$total_licenses_cost : get(projectByID, '$total_licenses_cost', '-')
    const total_licenses_price = isPresale ? presale_snapshot.$total_licenses_price : get(projectByID, '$total_licenses_price', '-')
    const total_change_requests_license_cost = isPresale ? presale_snapshot.$total_change_requests_license_cost : get(projectByID, '$total_change_requests_license_cost', '-')
    const total_change_requests_license_price = isPresale ? presale_snapshot.$total_change_requests_license_price : get(projectByID, '$total_change_requests_license_price', '-')
    const total_change_requests_license_gross_profit = isPresale ? presale_snapshot.$total_change_requests_license_gross_profit : get(projectByID, '$total_change_requests_license_gross_profit', '-')
    const total_change_requests_license_gross_profit_ratio = isPresale ? presale_snapshot.$total_change_requests_license_gross_profit_ratio : get(projectByID, '$total_change_requests_license_gross_profit_ratio', '-')
    const total_contract_licenses_price_with_cr = isPresale ? presale_snapshot.$total_contract_licenses_price_with_cr : get(projectByID, '$total_contract_licenses_price_with_cr', '-')
    const total_contract_licenses_cost_with_cr = isPresale ? presale_snapshot.$total_contract_licenses_cost_with_cr : get(projectByID, '$total_contract_licenses_cost_with_cr', '-')
    const total_contract_licenses_gross_profit_with_cr = isPresale ? presale_snapshot.$total_contract_licenses_gross_profit_with_cr : get(projectByID, '$total_contract_licenses_gross_profit_with_cr', '-')
    const total_contract_licenses_gross_profit_ratio_with_cr = isPresale ? presale_snapshot.$total_contract_licenses_gross_profit_ratio_with_cr : get(projectByID, '$total_contract_licenses_gross_profit_ratio_with_cr', '-')
    const total_max_licenses_gross_profit = isPresale ? presale_snapshot.$total_max_licenses_gross_profit : get(projectByID, '$total_max_licenses_gross_profit', '-')
    const total_max_licenses_gross_profit_ratio = isPresale ? presale_snapshot.$total_max_licenses_gross_profit_ratio : get(projectByID, '$total_max_licenses_gross_profit_ratio', '-')
    const total_min_licenses_price = isPresale ? presale_snapshot.$total_min_licenses_price : get(projectByID, '$total_min_licenses_price', '-')
    const total_min_licenses_gross_profit = isPresale ? presale_snapshot.$total_min_licenses_gross_profit : get(projectByID, '$total_min_licenses_gross_profit', '-')
    const total_licenses_gross_profit = isPresale ? presale_snapshot.$total_licenses_gross_profit : get(projectByID, '$total_licenses_gross_profit', '-')
    const total_licenses_gross_profit_ratio = isPresale ? presale_snapshot.$total_licenses_gross_profit_ratio : get(projectByID, '$total_licenses_gross_profit_ratio', '-')
    const total_licenses_discount_price = isPresale ? presale_snapshot.$total_licenses_discount_price : get(projectByID, '$total_licenses_discount_price', '-')
    const total_licenses_discount_ratio = isPresale ? presale_snapshot.$total_licenses_discount_ratio : get(projectByID, '$total_licenses_discount_ratio', '-')
    // License Editable
    const project_license_ratio_minimum = isPresale ? presale_snapshot.project_license_ratio_minimum : get(this.state, 'project_license_ratio_minimum', 0)
    const project_license_contract_price = isPresale ? presale_snapshot.project_license_contract_price : get(this.state, 'project_license_contract_price', 0)

    // Other Services
    const total_other_service_cost = isPresale ? presale_snapshot.$total_other_service_cost : get(projectByID, '$total_other_service_cost', '-')
    // const total_other_service_price = isPresale ? presale_snapshot.$total_other_service_price : get(projectByID, '$total_other_service_price', '-')
    const total_other_service_gross_profit = isPresale ? presale_snapshot.$total_other_service_gross_profit : get(projectByID, '$total_other_service_gross_profit', '-')
    const total_other_service_gross_profit_ratio = isPresale ? presale_snapshot.$total_other_service_gross_profit_ratio : get(projectByID, '$total_other_service_gross_profit_ratio', '-')
    const total_contract_other_service_price_with_cr = isPresale ? presale_snapshot.$total_contract_other_service_price_with_cr : get(projectByID, '$total_contract_other_service_price_with_cr', '-')
    const total_contract_other_service_cost_with_cr = isPresale ? presale_snapshot.$total_contract_other_service_cost_with_cr : get(projectByID, '$total_contract_other_service_cost_with_cr', '-')
    const total_contract_other_service_gross_profit_with_cr = isPresale ? presale_snapshot.$total_contract_other_service_gross_profit_with_cr : get(projectByID, '$total_contract_other_service_gross_profit_with_cr', '-')
    const total_contract_other_service_gross_profit_ratio_with_cr = isPresale ? presale_snapshot.$total_contract_other_service_gross_profit_ratio_with_cr : get(projectByID, '$total_contract_other_service_gross_profit_ratio_with_cr', '-')
    const total_change_requests_other_service_cost = isPresale ? presale_snapshot.$total_change_requests_other_service_cost : get(projectByID, '$total_change_requests_other_service_cost', '-')
    const total_change_requests_other_service_price = isPresale ? presale_snapshot.$total_change_requests_other_service_price : get(projectByID, '$total_change_requests_other_service_price', '-')
    const total_change_requests_other_service_gross_profit = isPresale ? presale_snapshot.$total_change_requests_other_service_gross_profit : get(projectByID, '$total_change_requests_other_service_gross_profit', '-')
    const total_change_requests_other_service_gross_profit_ratio = isPresale ? presale_snapshot.$total_change_requests_other_service_gross_profit_ratio : get(projectByID, '$total_change_requests_other_service_gross_profit_ratio', '-')
    const total_other_service_max_revenue = isPresale ? presale_snapshot.$total_other_service_max_revenue : get(projectByID, '$total_other_service_max_revenue', '-')
    const total_other_service_max_gross_profit = isPresale ? presale_snapshot.$total_other_service_max_gross_profit : get(projectByID, '$total_other_service_max_gross_profit', '-')
    const total_other_service_max_gross_profit_ratio = isPresale ? presale_snapshot.$total_other_service_max_gross_profit_ratio : get(projectByID, '$total_other_service_max_gross_profit_ratio', '-')
    const total_other_service_min_revenue = isPresale ? presale_snapshot.$total_other_service_min_revenue : get(projectByID, '$total_other_service_min_revenue', '-')
    const total_other_service_min_gross_profit = isPresale ? presale_snapshot.$total_other_service_min_gross_profit : get(projectByID, '$total_other_service_min_gross_profit', '-')
    const total_other_service_discount_price = isPresale ? presale_snapshot.$total_other_service_discount_price : get(projectByID, '$total_other_service_discount_price', '-')
    const total_other_service_discount_ratio = isPresale ? presale_snapshot.$total_other_service_discount_ratio : get(projectByID, '$total_other_service_discount_ratio', '-')
    const total_service_cr_revenue_mandays_avg = isPresale ? presale_snapshot.$total_service_cr_revenue_mandays_avg : get(projectByID, '$total_service_cr_revenue_mandays_avg', '-')
    // Other Services Editable
    const project_other_service_ratio_minimum = isPresale ? presale_snapshot.project_other_service_ratio_minimum : get(this.state, 'project_other_service_ratio_minimum', 0)
    const project_other_service_contract_price = isPresale ? presale_snapshot.project_other_service_contract_price : get(this.state, 'project_other_service_contract_price', 0)

    // STD Services
    const standard_total_service_max_revenue = isPresale ? presale_snapshot.$standard_total_service_max_revenue : get(projectByID, '$standard_total_service_max_revenue', '-')
    const standard_total_service_cost = isPresale ? presale_snapshot.$standard_total_service_cost : get(projectByID, '$standard_total_service_cost', '-')
    const standard_total_service_max_gross_profit = isPresale ? presale_snapshot.$standard_total_service_max_gross_profit : get(projectByID, '$standard_total_service_max_gross_profit', '-')
    const standard_total_service_max_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_service_max_gross_profit_ratio : get(projectByID, '$standard_total_service_max_gross_profit_ratio', '-')
    const standard_total_service_max_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_max_gross_profit_mandays_avg : get(projectByID, '$standard_total_service_max_gross_profit_mandays_avg', '-')
    const standard_total_service_max_revenue_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_max_revenue_mandays_avg : get(projectByID, '$standard_total_service_max_revenue_mandays_avg', '-')
    const standard_total_service_min_revenue_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_min_revenue_mandays_avg : get(projectByID, '$standard_total_service_min_revenue_mandays_avg', '-')
    const standard_total_service_min_revenue = isPresale ? presale_snapshot.$standard_total_service_min_revenue : get(projectByID, '$standard_total_service_min_revenue', '-')
    const standard_total_service_min_gross_profit = isPresale ? presale_snapshot.$standard_total_service_min_gross_profit : get(projectByID, '$standard_total_service_min_gross_profit', '-')
    const standard_total_service_min_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_min_gross_profit_mandays_avg : get(projectByID, '$standard_total_service_min_gross_profit_mandays_avg', '-')
    const standard_total_service_contract_gross_profit = isPresale ? presale_snapshot.$standard_total_service_contract_gross_profit : get(projectByID, '$standard_total_service_contract_gross_profit', '-')
    const standard_total_service_contract_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_service_contract_gross_profit_ratio : get(projectByID, '$standard_total_service_contract_gross_profit_ratio', '-')
    const standard_total_service_contract_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_contract_gross_profit_mandays_avg : get(projectByID, '$standard_total_service_contract_gross_profit_mandays_avg', '-')
    const standard_total_service_contract_revenue_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_contract_revenue_mandays_avg : get(projectByID, '$standard_total_service_contract_revenue_mandays_avg', '-')
    const standard_total_service_discount_price = isPresale ? presale_snapshot.$standard_total_service_discount_price : get(projectByID, '$standard_total_service_discount_price', '-')
    const standard_total_service_discount_ratio = isPresale ? presale_snapshot.$standard_total_service_discount_ratio : get(projectByID, '$standard_total_service_discount_ratio', '-')
    const standard_total_service_cr_revenue_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_cr_revenue_mandays_avg : get(projectByID, '$standard_total_service_cr_revenue_mandays_avg', '-')
    const standard_total_service_contract_with_cr_price = isPresale ? presale_snapshot.$standard_total_service_contract_with_cr_price : get(projectByID, '$standard_total_service_contract_with_cr_price', '-')
    const standard_total_service_contract_with_cr_gross_profit = isPresale ? presale_snapshot.$standard_total_service_contract_with_cr_gross_profit : get(projectByID, '$standard_total_service_contract_with_cr_gross_profit', '-')
    const standard_total_service_contract_with_cr_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_service_contract_with_cr_gross_profit_ratio : get(projectByID, '$standard_total_service_contract_with_cr_gross_profit_ratio', '-')
    const standard_total_service_contract_with_cr_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_contract_with_cr_gross_profit_mandays_avg : get(projectByID, '$standard_total_service_contract_with_cr_gross_profit_mandays_avg', '-')
    const standard_total_service_revenue_mandays_avg = isPresale ? presale_snapshot.$standard_total_service_revenue_mandays_avg : get(projectByID, '$standard_total_service_revenue_mandays_avg', '-')
    const standard_total_service_revenue_mandays_avg_submit = isPresale ? presale_snapshot_submit.$standard_total_service_revenue_mandays_avg : get(projectSubmit, '$standard_total_service_revenue_mandays_avg', '-')

    // ACT Services
    // const total_service_max_revenue = get(projectByID, '$total_service_max_revenue', '-')
    // const total_service_cost = get(projectByID, '$total_service_cost', '-')
    // const total_service_max_gross_profit = get(projectByID, '$total_service_max_gross_profit', '-')
    // const total_service_max_gross_profit_ratio = get(projectByID, '$total_service_max_gross_profit_ratio', '-')
    // const total_service_max_gross_profit_mandays_avg = get(projectByID, '$total_service_max_gross_profit_mandays_avg', '-')
    // const total_service_min_revenue = get(projectByID, '$total_service_min_revenue', '-')
    // const total_service_min_gross_profit = get(projectByID, '$total_service_min_gross_profit', '-')
    // const total_service_min_gross_profit_mandays_avg = get(projectByID, '$total_service_min_gross_profit_mandays_avg', '-')
    // const total_service_contract_gross_profit = get(projectByID, '$total_service_contract_gross_profit', '-')
    // const total_service_contract_gross_profit_ratio = get(projectByID, '$total_service_contract_gross_profit_ratio', '-')
    // const total_service_contract_gross_profit_mandays_avg = get(projectByID, '$total_service_contract_gross_profit_mandays_avg', '-')
    // const total_service_discount_price = get(projectByID, '$total_service_discount_price', '-')
    // const total_service_discount_ratio = get(projectByID, '$total_service_discount_ratio', '-')
    // const total_service_contract_with_cr_price = get(projectByID, '$total_service_contract_with_cr_price', '-')
    // const total_service_contract_with_cr_gross_profit = get(projectByID, '$total_service_contract_with_cr_gross_profit', '-')
    // const total_service_contract_with_cr_gross_profit_ratio = get(projectByID, '$total_service_contract_with_cr_gross_profit_ratio', '-')
    // const total_service_contract_with_cr_gross_profit_mandays_avg = get(projectByID, '$total_service_contract_with_cr_gross_profit_mandays_avg', '-')

    const service_man_days_with_cr = isPresale ? presale_snapshot.$service_man_days_with_cr : get(projectByID, '$service_man_days_with_cr', '-')
    const sum_man_days = isPresale ? presale_snapshot.$service_man_days : get(projectByID, '$service_man_days', '-')
    const weight_man_days = isPresale ? presale_snapshot.$weight_man_days : get(projectByID, '$weight_man_days', '-')
    const max_revenue_by_wmd = isPresale ? presale_snapshot.$max_revenue_by_wmd : get(projectByID, '$max_revenue_by_wmd', '-')
    const min_revenue_by_wmd = isPresale ? presale_snapshot.$min_revenue_by_wmd : get(projectByID, '$min_revenue_by_wmd', '-')
    const contract_revenue_by_wmd = isPresale ? presale_snapshot.$contract_revenue_by_wmd : get(projectByID, '$contract_revenue_by_wmd', '-')
    const price_revenue_by_wmd = isPresale ? presale_snapshot.$price_revenue_by_wmd : get(projectByID, '$price_revenue_by_wmd', '-')

    // Service (Standard)
    const standard_total_pps_service_price = isPresale ? presale_snapshot.$standard_total_pps_service_price : get(projectByID, '$standard_total_pps_service_price', '-')
    const standard_total_pps_service_cost = isPresale ? presale_snapshot.$standard_total_pps_service_cost : get(projectByID, '$standard_total_pps_service_cost', '-')
    const standard_total_pps_service_gross_profit = isPresale ? presale_snapshot.$standard_total_pps_service_gross_profit : get(projectByID, '$standard_total_pps_service_gross_profit', '-')
    const standard_total_pps_service_gross_profit_ratio = isPresale ? presale_snapshot.$standard_total_pps_service_gross_profit_ratio : get(projectByID, '$standard_total_pps_service_gross_profit_ratio', '-')
    const standard_total_pps_service_gross_profit_mandays_avg = isPresale ? presale_snapshot.$standard_total_pps_service_gross_profit_mandays_avg : get(projectByID, '$standard_total_pps_service_gross_profit_mandays_avg', '-')

    const standard_total_pps_service_price_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_price : get(projectSubmit, '$standard_total_pps_service_price', '-')
    const standard_total_pps_service_cost_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_cost : get(projectSubmit, '$standard_total_pps_service_cost', '-')
    const standard_total_pps_service_gross_profit_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_gross_profit : get(projectSubmit, '$standard_total_pps_service_gross_profit', '-')
    const standard_total_pps_service_gross_profit_ratio_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_gross_profit_ratio : get(projectSubmit, '$standard_total_pps_service_gross_profit_ratio', '-')
    const standard_total_pps_service_gross_profit_mandays_avg_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_gross_profit_mandays_avg : get(projectSubmit, '$standard_total_pps_service_gross_profit_mandays_avg', '-')

    // Service (Actual)
    const total_pps_service_price = isPresale ? presale_snapshot.$total_pps_service_price : get(projectByID, '$total_pps_service_price', '-')
    const total_pps_service_cost = isPresale ? presale_snapshot.$total_pps_service_cost : get(projectByID, '$total_pps_service_cost', '-')
    const total_pps_service_gross_profit = isPresale ? presale_snapshot.$total_pps_service_gross_profit : get(projectByID, '$total_pps_service_gross_profit', '-')
    const total_pps_service_gross_profit_ratio = isPresale ? presale_snapshot.$total_pps_service_gross_profit_ratio : get(projectByID, '$total_pps_service_gross_profit_ratio', '-')
    const total_pps_service_gross_profit_mandays_avg = isPresale ? presale_snapshot.$total_pps_service_gross_profit_mandays_avg : get(projectByID, '$total_pps_service_gross_profit_mandays_avg', '-')

    const total_pps_service_price_submit = isPresale ? presale_snapshot_submit.$total_pps_service_price : get(projectSubmit, '$total_pps_service_price', '-')
    const total_pps_service_cost_submit = isPresale ? presale_snapshot_submit.$total_pps_service_cost : get(projectSubmit, '$total_pps_service_cost', '-')
    const total_pps_service_gross_profit_submit = isPresale ? presale_snapshot_submit.$total_pps_service_gross_profit : get(projectSubmit, '$total_pps_service_gross_profit', '-')
    const total_pps_service_gross_profit_ratio_submit = isPresale ? presale_snapshot_submit.$total_pps_service_gross_profit_ratio : get(projectSubmit, '$total_pps_service_gross_profit_ratio', '-')
    const total_pps_service_gross_profit_mandays_avg_submit = isPresale ? presale_snapshot_submit.$total_pps_service_gross_profit_mandays_avg : get(projectSubmit, '$total_pps_service_gross_profit_mandays_avg', '-')

    // Service (Man-days)
    // const standard_total_pps_service_price = isPresale ? presale_snapshot.$standard_total_pps_service_price : get(projectByID, '$standard_total_pps_service_price', '-')
    const standard_total_pps_service_man_days = isPresale ? presale_snapshot.$standard_total_pps_service_man_days : get(projectByID, '$standard_total_pps_service_man_days', '-')
    const standard_total_pps_service_weight_man_days = isPresale ? presale_snapshot.$standard_total_pps_service_weight_man_days : get(projectByID, '$standard_total_pps_service_weight_man_days', '-')
    const standard_total_pps_service_weight_man_days_revenue = isPresale ? presale_snapshot.$standard_total_pps_service_weight_man_days_revenue : get(projectByID, '$standard_total_pps_service_weight_man_days_revenue', '-')

    const standard_total_pps_service_man_days_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_man_days : get(projectSubmit, '$standard_total_pps_service_man_days', '-')
    const standard_total_pps_service_weight_man_days_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_weight_man_days : get(projectSubmit, '$standard_total_pps_service_weight_man_days', '-')
    const standard_total_pps_service_weight_man_days_revenue_submit = isPresale ? presale_snapshot_submit.$standard_total_pps_service_weight_man_days_revenue : get(projectSubmit, '$standard_total_pps_service_weight_man_days_revenue', '-')

    // Other Service
    const total_pps_other_service_price = isPresale ? presale_snapshot.$total_pps_other_service_price : get(projectByID, '$total_pps_other_service_price', '-')
    const total_pps_other_service_cost = isPresale ? presale_snapshot.$total_pps_other_service_cost : get(projectByID, '$total_pps_other_service_cost', '-')
    const total_pps_other_service_gross_profit = isPresale ? presale_snapshot.$total_pps_other_service_gross_profit : get(projectByID, '$total_pps_other_service_gross_profit', '-')
    const total_pps_other_service_gross_profit_ratio = isPresale ? presale_snapshot.$total_pps_other_service_gross_profit_ratio : get(projectByID, '$total_pps_other_service_gross_profit_ratio', '-')

    const total_pps_other_service_price_submit = isPresale ? presale_snapshot_submit.$total_pps_other_service_price : get(projectSubmit, '$total_pps_other_service_price', '-')
    const total_pps_other_service_cost_submit = isPresale ? presale_snapshot_submit.$total_pps_other_service_cost : get(projectSubmit, '$total_pps_other_service_cost', '-')
    const total_pps_other_service_gross_profit_submit = isPresale ? presale_snapshot_submit.$total_pps_other_service_gross_profit : get(projectSubmit, '$total_pps_other_service_gross_profit', '-')
    const total_pps_other_service_gross_profit_ratio_submit = isPresale ? presale_snapshot_submit.$total_pps_other_service_gross_profit_ratio : get(projectSubmit, '$total_pps_other_service_gross_profit_ratio', '-')

    // License
    const total_pps_licenses_price = isPresale ? presale_snapshot.$total_pps_licenses_price : get(projectByID, '$total_pps_licenses_price', '-')
    const total_pps_licenses_cost = isPresale ? presale_snapshot.$total_pps_licenses_cost : get(projectByID, '$total_pps_licenses_cost', '-')
    const total_pps_licenses_gross_profit = isPresale ? presale_snapshot.$total_pps_licenses_gross_profit : get(projectByID, '$total_pps_licenses_gross_profit', '-')
    const total_pps_licenses_gross_profit_ratio = isPresale ? presale_snapshot.$total_pps_licenses_gross_profit_ratio : get(projectByID, '$total_pps_licenses_gross_profit_ratio', '-')

    const total_pps_licenses_price_submit = isPresale ? presale_snapshot_submit.$total_pps_licenses_price : get(projectSubmit, '$total_pps_licenses_price', '-')
    const total_pps_licenses_cost_submit = isPresale ? presale_snapshot_submit.$total_pps_licenses_cost : get(projectSubmit, '$total_pps_licenses_cost', '-')
    const total_pps_licenses_gross_profit_submit = isPresale ? presale_snapshot_submit.$total_pps_licenses_gross_profit : get(projectSubmit, '$total_pps_licenses_gross_profit', '-')
    const total_pps_licenses_gross_profit_ratio_submit = isPresale ? presale_snapshot_submit.$total_pps_licenses_gross_profit_ratio : get(projectSubmit, '$total_pps_licenses_gross_profit_ratio', '-')

    // Hardware
    const total_pps_hardwares_price = isPresale ? presale_snapshot.$total_pps_hardwares_price : get(projectByID, '$total_pps_hardwares_price', '-')
    const total_pps_hardwares_cost = isPresale ? presale_snapshot.$total_pps_hardwares_cost : get(projectByID, '$total_pps_hardwares_cost', '-')
    const total_pps_hardwares_gross_profit = isPresale ? presale_snapshot.$total_pps_hardwares_gross_profit : get(projectByID, '$total_pps_hardwares_gross_profit', '-')
    const total_pps_hardwares_gross_profit_ratio = isPresale ? presale_snapshot.$total_pps_hardwares_gross_profit_ratio : get(projectByID, '$total_pps_hardwares_gross_profit_ratio', '-')

    const total_pps_hardwares_price_submit = isPresale ? presale_snapshot_submit.$total_pps_hardwares_price : get(projectSubmit, '$total_pps_hardwares_price', '-')
    const total_pps_hardwares_cost_submit = isPresale ? presale_snapshot_submit.$total_pps_hardwares_cost : get(projectSubmit, '$total_pps_hardwares_cost', '-')
    const total_pps_hardwares_gross_profit_submit = isPresale ? presale_snapshot_submit.$total_pps_hardwares_gross_profit : get(projectSubmit, '$total_pps_hardwares_gross_profit', '-')
    const total_pps_hardwares_gross_profit_ratio_submit = isPresale ? presale_snapshot_submit.$total_pps_hardwares_gross_profit_ratio : get(projectSubmit, '$total_pps_hardwares_gross_profit_ratio', '-')

    const fallbackNanOrInfinity = (number) => {
      return ['NaN', 'Infinity', '-Infinity'].includes(number) ? '0.00' : number
    }

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable bordered hover>
        <Header onClick={() => this.setState({ collapse_overall: !this.state.collapse_overall })}>
          <tr>
            <th>
              <Icon
                style={{ transform: this.state.collapse_overall ? 'rotate(180deg)' : 'rotate(270deg)' }}
                src={left_arrow}
                collapse={!this.state.collapse_overall}
              />
            </th>
            <th style={{ paddingLeft: 0 }}>Breakdown Revenues</th>
          </tr>
        </Header>
        <HeaderEdit style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr>
            <HeaderWrapper>
              {!editBreakDown
                && canEdit
                && activeToggle === 1
                &&
                <EditPriceWrapper disabled={project_status === 'IMPLEMENTING' || project_status === 'DONE'}>
                  <Button
                    theme='#28a745'
                    width='100px'
                    height='26px'
                    icon={<FaRegEdit style={{ fontSize: 16 }} />}
                    disabled={project_status === 'IMPLEMENTING' || project_status === 'DONE'}
                    onClick={() => this.props.clickEdit()}
                  >
                    Edit Price
                  </Button>
                  <div id='tooltip'>Cannot edit when the project is on implementing</div>
                </EditPriceWrapper>
              }
              {editBreakDown &&
                <Button
                  theme='#28a745'
                  width='70px'
                  height='26px'
                  style={{ marginLeft: 12 }}
                  icon={<AiOutlineSave style={{ fontSize: 16 }} />}
                  onClick={() => this.props.editBreakDownRevenues(this.state)}
                >
                  Save
                </Button>
              }
              {editBreakDown &&
                <Button
                  theme='#6c757d'
                  width='70px'
                  height='26px'
                  style={{ marginLeft: 12 }}
                  onClick={() => {
                    this.setState({ projectByID: null })
                    this.props.cancelEdit()
                  }}
                >
                  Cancel
                </Button>
              }
              {editBreakDown &&
                <Button
                  theme='#D44B49'
                  width='70px'
                  height='26px'
                  style={{ marginLeft: 12 }}
                  onClick={() => this.props.clickCalculate(this.state)}
                >
                  Calculate
                </Button>
              }
            </HeaderWrapper>
          </tr>
        </HeaderEdit>
        <SubHeader style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr style={{ fontFamily: 'Gotham' }}>
            <HeadTable>Services Revenue</HeadTable>
            <HeadTable>List Price<Text>(A)</Text></HeadTable>
            <HeadTable>Min Price<Text>(B)</Text></HeadTable>
            <HeadTable>Contract Price<Text>(C)</Text></HeadTable>
            <HeadTable>Diff. List Price<Text>(D = C - A)</Text></HeadTable>
            <HeadTable>CR Price<Text>(E)</Text></HeadTable>
            <HeadTable>Current Version<Text>(Forecast from PPS)</Text></HeadTable>
            <HeadTable>Latest Approved<Text>(Forecast from PPS)</Text></HeadTable>
          </tr>
        </SubHeader>
        <BodyTable style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr>
            <td>Resource Revenue</td>
            <td>
              {(() => { /* total_service_max_revenue */
                if (projectType === CONSTANTS.SUPPORT) return total_service_max_revenue
                else {
                  if (activeToggle === 1) return standard_total_service_max_revenue
                  else if (activeToggle === 2) return standard_total_service_max_revenue
                  else return total_service_max_revenue
                }
              })()}
            </td>
            <td>
              {(() => { /* total_service_min_revenue */
                if (projectType === CONSTANTS.SUPPORT) return total_service_min_revenue
                else {
                  if (activeToggle === 1) return standard_total_service_min_revenue
                  else if (activeToggle === 2) return standard_total_service_min_revenue
                  else return total_service_min_revenue
                }
              })()}
            </td>
            <td>
              <NumberField
                name='project_service_contract_price'
                disabled={!get(this.props, 'editBreakDown') || project_status === 'IMPLEMENTING'}
                value={project_service_contract_price}
                thousandSeparator={true}
                allowEmptyFormatting={true}
                decimalScale={2}
                fixedDecimalScale={true}
                onBlur={(e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  this.handleInput(e)
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode === 13) {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    await this.handleInput(e)
                    this.props.clickCalculate(this.state)
                  }
                }}
              />
            </td>
            <td>
              {(() => {
                if (activeToggle === 1 || activeToggle === 2) return `${standard_total_service_discount_price} (${fallbackNanOrInfinity(standard_total_service_discount_ratio)} %)`
                return `${total_service_discount_price} (${fallbackNanOrInfinity(total_service_discount_ratio)} %)`
              })()}
            </td>
            <td>{total_change_requests_service_price}</td>
            <td>
              {(() => {
                if (activeToggle === 1 || activeToggle === 2) return decimalFormatter(standard_total_pps_service_price)
                return decimalFormatter(total_pps_service_price)
              })()}
            </td>
            <td>
              {(() => { /* total_forcast */
                if (activeToggle === 1 || activeToggle === 2) return decimalFormatter(standard_total_pps_service_price_submit)
                return decimalFormatter(total_pps_service_price_submit)
              })()}
            </td>
          </tr>
          {canShow &&
            <tr>
              <td>Total Cost</td>
              <td>
                {(() => {
                  if (projectType === CONSTANTS.SUPPORT) {
                    return total_service_cost
                  } else {
                    if (activeToggle === 1 || activeToggle === 2) return standard_total_service_cost
                    else return total_service_cost
                  }
                })()}
              </td>
              <td>
                {(() => {
                  if (projectType === CONSTANTS.SUPPORT) {
                    return total_service_cost
                  } else {
                    if (activeToggle === 1 || activeToggle === 2) return standard_total_service_cost
                    else return total_service_cost
                  }
                })()}
              </td>
              <td>
                {(() => {
                  if (projectType === CONSTANTS.SUPPORT) {
                    return total_service_cost
                  } else {
                    if (activeToggle === 1 || activeToggle === 2) return standard_total_service_cost
                    else return total_service_cost
                  }
                })()}
              </td>
              <td>-</td>
              <td>
                {total_change_requests_service_cost}
              </td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return standard_total_pps_service_cost
                  else return total_pps_service_cost
                })()}
              </td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return standard_total_pps_service_cost_submit
                  else return total_pps_service_cost_submit
                })()}
              </td>
            </tr>
          }
          <tr>
            <td>MD (Days)</td>
            <td>{sum_man_days}</td>
            <td>{sum_man_days}</td>
            <td>{sum_man_days}</td>
            <td>-</td>
            <td>{total_change_requests_service_man_days}</td>
            <td>{standard_total_pps_service_man_days}</td>
            <td>{standard_total_pps_service_man_days_submit}</td>
          </tr>
          <tr>
            <td>Rev/MD</td>
            <td>
              {(() => { /* total_service_max_revenue */
                let md = convert2Number(sum_man_days)
                let revenue = convert2Number(total_service_max_revenue)
                if ((activeToggle === 1 || activeToggle === 2) && projectType !== CONSTANTS.SUPPORT) revenue = convert2Number(standard_total_service_max_revenue)
                return decimalFormatter(revenue / md)
              })()}
            </td>
            <td>
              {(() => { /* total_service_min_revenue */
                let md = convert2Number(sum_man_days)
                let revenue = convert2Number(total_service_min_revenue)
                if ((activeToggle === 1 || activeToggle === 2) && projectType !== CONSTANTS.SUPPORT) revenue = convert2Number(standard_total_service_min_revenue)
                return decimalFormatter(revenue / md)
              })()}
            </td>
            <td>
              {(() => {
                let md = convert2Number(sum_man_days)
                let revenue = convert2Number(project_service_contract_price)
                return decimalFormatter(revenue / md)
              })()}
            </td>
            <td>
              {(() => {
                return "-"
              })()}
            </td>
            <td>
              {(() => {
                let md = convert2Number(total_change_requests_service_man_days)
                let revenue = convert2Number(project_service_contract_price)
                return decimalFormatter(revenue / md)
              })()}
            </td>
            <td>
              {(() => {
                let md = convert2Number(standard_total_pps_service_man_days)
                let revenue = convert2Number(total_pps_service_price)
                if (activeToggle === 1 || activeToggle === 2) revenue = convert2Number(standard_total_pps_service_price)
                return decimalFormatter(revenue / md)
              })()}
            </td>
            <td>
              {(() => { /* total_forcast */
                let md = convert2Number(standard_total_pps_service_man_days_submit)
                let revenue = convert2Number(total_pps_service_price_submit)
                if (activeToggle === 1 || activeToggle === 2) revenue = convert2Number(standard_total_pps_service_price_submit)
                return decimalFormatter(revenue / md)
              })()}
            </td>
          </tr>
          {!canShow &&
            <tr>
              <td>Weighted MD</td>
              <td>{weight_man_days}</td>
              <td>{weight_man_days}</td>
              <td>{weight_man_days}</td>
              <td>-</td>
              <td>-</td>
              <td>{standard_total_pps_service_weight_man_days}</td>
              <td>{standard_total_pps_service_weight_man_days_submit}</td>
            </tr>
          }
          {!canShow &&
            <tr>
              <td>Rev/Weighted MD</td>
              <td>
                {(() => { /* total_service_max_revenue */
                  let md = convert2Number(weight_man_days)
                  let revenue = convert2Number(total_service_max_revenue)
                  if ((activeToggle === 1 || activeToggle === 2) && projectType !== CONSTANTS.SUPPORT) revenue = convert2Number(standard_total_service_max_revenue)
                  return decimalFormatter(revenue / md)
                })()}
              </td>
              <td>
                {(() => { /* total_service_min_revenue */
                  let md = convert2Number(weight_man_days)
                  let revenue = convert2Number(total_service_min_revenue)
                  if ((activeToggle === 1 || activeToggle === 2) && projectType !== CONSTANTS.SUPPORT) revenue = convert2Number(standard_total_service_min_revenue)
                  return decimalFormatter(revenue / md)
                })()}
              </td>
              <td>
                {(() => {
                  let md = convert2Number(weight_man_days)
                  let revenue = convert2Number(project_service_contract_price)
                  return decimalFormatter(revenue / md)
                })()}
              </td>
              <td>
                {(() => {
                  return "-"
                })()}
              </td>
              <td>
                {(() => {
                  return "-"
                })()}
              </td>
              <td>
                {(() => {
                  let md = convert2Number(standard_total_pps_service_weight_man_days)
                  let revenue = convert2Number(total_pps_service_price)
                  if (activeToggle === 1 || activeToggle === 2) revenue = convert2Number(standard_total_pps_service_price)
                  return decimalFormatter(revenue / md)
                })()}
              </td>
              <td>
                {(() => { /* total_forcast */
                  let md = convert2Number(standard_total_pps_service_weight_man_days_submit)
                  let revenue = convert2Number(total_pps_service_price_submit)
                  if (activeToggle === 1 || activeToggle === 2) revenue = convert2Number(standard_total_pps_service_price_submit)
                  return decimalFormatter(revenue / md)
                })()}
              </td>
            </tr>
          }
          {canShow &&
            <tr>
              <td>Gross Profit</td>
              <td>
                {(() => { /* total_service_max_gross_profit */
                  if (projectType === CONSTANTS.SUPPORT) {
                    return total_service_max_gross_profit
                  } else {
                    if (activeToggle === 1 || activeToggle === 2) return standard_total_service_max_gross_profit
                    else return total_service_max_gross_profit
                  }
                })()}
              </td>
              <td>
                {(() => { /* total_service_min_gross_profit */
                  if (projectType === CONSTANTS.SUPPORT) {
                    return total_service_min_gross_profit
                  } else {
                    if (activeToggle === 1 || activeToggle === 2) return standard_total_service_min_gross_profit
                    else return total_service_min_gross_profit
                  }
                })()}
              </td>
              <td>
                {(() => { /* total_service_contract_gross_profit */
                  if (projectType === CONSTANTS.SUPPORT) {
                    return total_service_contract_gross_profit
                  } else {
                    if (activeToggle === 1 || activeToggle === 2) return standard_total_service_contract_gross_profit
                    else return total_service_contract_gross_profit
                  }
                })()}
              </td>
              <td>-</td>
              <td>
                {total_change_requests_service_gross_profit}
              </td>
              <td>
                {(() => { /* total_service_contract_with_cr_gross_profit */
                  if (activeToggle === 1 || activeToggle === 2) return standard_total_pps_service_gross_profit
                  else return total_pps_service_gross_profit
                })()}
              </td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return standard_total_pps_service_gross_profit_submit
                  else return total_pps_service_gross_profit_submit
                })()}
              </td>
            </tr>
          }
          {canShow &&
            <tr>
              <td>Gross Profit Ratio</td>
              <td>{(() => { /* total_service_max_gross_profit_ratio */
                if (projectType === CONSTANTS.SUPPORT) {
                  return `${fallbackNanOrInfinity(decimalFormatter(total_service_max_gross_profit_ratio))} %`
                } else {
                  if (activeToggle === 1 || activeToggle === 2) return `${fallbackNanOrInfinity(decimalFormatter(standard_total_service_max_gross_profit_ratio))} %`
                  else return `${fallbackNanOrInfinity(decimalFormatter(total_service_max_gross_profit_ratio))} %`
                }
              })()}
              </td>
              <td>{canShow ?
                <NumberField
                  key='project_service_ratio_minimum'
                  name='project_service_ratio_minimum'
                  disabled={!get(this.props, 'editBreakDown')}
                  value={project_service_ratio_minimum}
                  thousandSeparator={true}
                  decimalScale={2}
                  allowEmptyFormatting={true}
                  fixedDecimalScale={true}
                  onBlur={(e) => {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    this.handleInput(e)
                  }}
                  onKeyDown={async (e) => {
                    if (e.keyCode === 13) {
                      e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                      await this.handleInput(e)
                      this.props.clickCalculate(this.state)
                    }
                  }}
                /> :
                <NumberFormat
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  displayType='text'
                  value={fallbackNanOrInfinity(min_revenue_by_wmd)}
                />
              }
              </td>
              <td>
                {(() => { /* total_service_contract_gross_profit_ratio */
                  if (projectType === CONSTANTS.SUPPORT) {
                    return `${fallbackNanOrInfinity(total_service_contract_gross_profit_ratio)} %`
                  } else {
                    if (activeToggle === 1 || activeToggle === 2) return `${fallbackNanOrInfinity(standard_total_service_contract_gross_profit_ratio)} %`
                    else return `${fallbackNanOrInfinity(total_service_contract_gross_profit_ratio)} %`
                  }
                })()}
              </td>
              <td>-</td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return `${total_change_requests_service_gross_profit_ratio} %`
                  return `${total_change_requests_service_gross_profit_ratio} %`
                })()}
              </td>
              <td>
                {(() => { /* total_service_contract_with_cr_gross_profit_ratio */
                  if (activeToggle === 1 || activeToggle === 2) return `${fallbackNanOrInfinity(standard_total_pps_service_gross_profit_ratio)} %`
                  else return `${fallbackNanOrInfinity(total_pps_service_gross_profit_ratio)} %`
                })()}
              </td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return `${fallbackNanOrInfinity(standard_total_pps_service_gross_profit_ratio_submit)} %`
                  else return `${fallbackNanOrInfinity(total_pps_service_gross_profit_ratio_submit)} %`
                })()}
              </td>
            </tr>
          }
          {canShow &&
            <tr>
              <td>GP/MD</td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return fallbackNanOrInfinity(standard_total_service_max_gross_profit_mandays_avg)
                  else return fallbackNanOrInfinity(total_service_max_gross_profit_mandays_avg)
                })()}
              </td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return fallbackNanOrInfinity(standard_total_service_min_gross_profit_mandays_avg)
                  else return fallbackNanOrInfinity(total_service_min_gross_profit_mandays_avg)
                })()}
              </td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return fallbackNanOrInfinity(standard_total_service_contract_gross_profit_mandays_avg)
                  else return fallbackNanOrInfinity(total_service_contract_gross_profit_mandays_avg)
                })()}
              </td>
              <td>-</td>
              <td>-</td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_service_gross_profit_mandays_avg)
                  else return fallbackNanOrInfinity(total_pps_service_gross_profit_mandays_avg)
                })()}
              </td>
              <td>
                {(() => {
                  if (activeToggle === 1 || activeToggle === 2) return fallbackNanOrInfinity(standard_total_pps_service_gross_profit_mandays_avg_submit)
                  else return fallbackNanOrInfinity(total_pps_service_gross_profit_mandays_avg_submit)
                })()}
              </td>
            </tr>
          }
        </BodyTable>

        <SubHeader style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr style={{ fontFamily: 'Gotham' }}>
            <HeadTable>Other services Revenue</HeadTable>
            <HeadTable>List Price<Text>(A)</Text></HeadTable>
            <HeadTable>Min Price<Text>(B)</Text></HeadTable>
            <HeadTable>Contract Price<Text>(C)</Text></HeadTable>
            <HeadTable>Diff. List Price<Text>(D = C - A)</Text></HeadTable>
            <HeadTable>CR Price<Text>(E)</Text></HeadTable>
            <HeadTable>Current Version<Text>(Forecast from PPS)</Text></HeadTable>
            <HeadTable>Latest Approved<Text>(Forecast from PPS)</Text></HeadTable>
          </tr>
        </SubHeader>
        <BodyTable style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr>
            <td>Revenue</td>
            <td>{total_other_service_max_revenue}</td>
            <td>{total_other_service_min_revenue}</td>
            <td>{numeral(project_other_service_contract_price).format('0,0.00')}</td>
            {/* <td>
              <NumberField
                name='project_other_service_contract_price'
                disabled={ true }
                value={ project_other_service_contract_price }
                thousandSeparator={ true }
                allowEmptyFormatting={ true }
                decimalScale={ 2 }
                fixedDecimalScale={ true }
                onBlur={ (e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  this.handleInput(e)
                } }
                onKeyDown={ async (e) => {
                  if (e.keyCode === 13) {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    await this.handleInput(e)
                    this.props.clickCalculate(this.state)
                  }
                } }
              />
            </td> */}
            <td>{`${total_other_service_discount_price} (${fallbackNanOrInfinity(total_other_service_discount_ratio)} %)`}</td>
            <td>{total_change_requests_other_service_price}</td>
            <td>
              {financialFormatter(total_pps_other_service_price)}
            </td>
            <td>
              {financialFormatter(total_pps_other_service_price_submit)}
            </td>
          </tr>
          <tr>
            <td>Total Cost</td>
            <td>{total_other_service_cost}</td>
            <td>{total_other_service_cost}</td>
            <td>{total_other_service_cost}</td>
            <td>-</td>
            <td>{total_change_requests_other_service_cost}</td>
            <td>{total_pps_other_service_cost}</td>
            <td>{total_pps_other_service_cost_submit}</td>
          </tr>
          <tr>
            <td>Gross Profit</td>
            <td>{total_other_service_max_gross_profit}</td>
            <td>{total_other_service_min_gross_profit}</td>
            <td>{total_other_service_gross_profit}</td>
            <td>-</td>
            <td>{total_change_requests_other_service_gross_profit}</td>
            <td>{total_pps_other_service_gross_profit}</td>
            <td>{total_pps_other_service_gross_profit_submit}</td>
          </tr>
          <tr>
            <td>Gross Profit Ratio</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_other_service_max_gross_profit_ratio))} %</td>
            <td>
              <NumberField
                key='project_other_service_ratio_minimum'
                name='project_other_service_ratio_minimum'
                disabled={!get(this.props, 'editBreakDown')}
                value={decimalFormatter(project_other_service_ratio_minimum)}
                thousandSeparator={true}
                decimalScale={2}
                allowEmptyFormatting={true}
                fixedDecimalScale={true}
                onBlur={(e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  this.handleInput(e)
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode === 13) {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    await this.handleInput(e)
                    this.props.clickCalculate(this.state)
                  }
                }}
              />%
            </td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_other_service_gross_profit_ratio))} %</td>
            <td>-</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_change_requests_other_service_gross_profit_ratio))} %</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_pps_other_service_gross_profit_ratio))} %</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_pps_other_service_gross_profit_ratio_submit))} %</td>
          </tr>
        </BodyTable>

        <SubHeader style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr style={{ fontFamily: 'Gotham' }}>
            <HeadTable>License/MA Revenue</HeadTable>
            <HeadTable>List Price<Text>(A)</Text></HeadTable>
            <HeadTable>Min Price<Text>(B)</Text></HeadTable>
            <HeadTable>Contract Price<Text>(C)</Text></HeadTable>
            <HeadTable>Diff. List Price<Text>(D = C - A)</Text></HeadTable>
            <HeadTable>CR Price<Text>(E)</Text></HeadTable>
            <HeadTable>Current Version<Text>(Forecast from PPS)</Text></HeadTable>
            <HeadTable>Latest Approved<Text>(Forecast from PPS)</Text></HeadTable>
          </tr>
        </SubHeader>
        <BodyTable style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr>
            <td>Revenue</td>
            <td>{total_licenses_price}</td>
            <td>{total_min_licenses_price}</td>
            <td>{numeral(project_license_contract_price).format('0,0.00')}</td>
            {/* <td>
              <NumberField
                key='project_license_contract_price'
                name='project_license_contract_price'
                disabled={ true }
                value={ project_license_contract_price }
                thousandSeparator={ true }
                allowEmptyFormatting={ true }
                decimalScale={ 2 }
                fixedDecimalScale={ true }
                onBlur={ (e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  this.handleInput(e)
                } }
                onKeyDown={ async (e) => {
                  if (e.keyCode === 13) {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    await this.handleInput(e)
                    this.props.clickCalculate(this.state)
                  }
                } }
              />
            </td> */}
            <td>{`${total_licenses_discount_price} (${fallbackNanOrInfinity(total_licenses_discount_ratio)} %)`}</td>
            <td>{total_change_requests_license_price}</td>
            <td>
              {financialFormatter(total_pps_licenses_price)}
            </td>
            <td>
              {financialFormatter(total_pps_licenses_price_submit)}
            </td>
          </tr>
          <tr>
            <td>Total Cost</td>
            <td>{total_licenses_cost}</td>
            <td>{total_licenses_cost}</td>
            <td>{total_licenses_cost}</td>
            <td>-</td>
            <td>{total_change_requests_license_cost}</td>
            <td>{total_pps_licenses_cost}</td>
            <td>{total_pps_licenses_cost_submit}</td>
          </tr>
          <tr>
            <td>Gross Profit</td>
            <td>{total_max_licenses_gross_profit}</td>
            <td>{total_min_licenses_gross_profit}</td>
            <td>{total_licenses_gross_profit}</td>
            <td>-</td>
            <td>{total_change_requests_license_gross_profit}</td>
            <td>{total_pps_licenses_gross_profit}</td>
            <td>{total_pps_licenses_gross_profit_submit}</td>
          </tr>
          <tr>
            <td>Gross Profit Ratio</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_max_licenses_gross_profit_ratio))} %</td>
            <td>
              <NumberPerField
                key='project_license_ratio_minimum'
                name='project_license_ratio_minimum'
                disabled={!get(this.props, 'editBreakDown')}
                value={decimalFormatter(project_license_ratio_minimum)}
                thousandSeparator={true}
                allowEmptyFormatting={true}
                decimalScale={2}
                fixedDecimalScale={true}
                onBlur={(e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  this.handleInput(e)
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode === 13) {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    await this.handleInput(e)
                    this.props.clickCalculate(this.state)
                  }
                }}
              />%
            </td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_licenses_gross_profit_ratio))} %</td>
            <td>-</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_change_requests_license_gross_profit_ratio))} %</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_pps_licenses_gross_profit_ratio))} %</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_pps_licenses_gross_profit_ratio_submit))} %</td>
          </tr>
        </BodyTable>

        <SubHeader style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr style={{ fontFamily: 'Gotham' }}>
            <HeadTable>Hardware/MA Revenue</HeadTable>
            <HeadTable>List Price<Text>(A)</Text></HeadTable>
            <HeadTable>Min Price<Text>(B)</Text></HeadTable>
            <HeadTable>Contract Price<Text>(C)</Text></HeadTable>
            <HeadTable>Diff. List Price<Text>(D = C - A)</Text></HeadTable>
            <HeadTable>CR Price<Text>(E)</Text></HeadTable>
            <HeadTable>Current Version<Text>(Forecast from PPS)</Text></HeadTable>
            <HeadTable>Latest Approved<Text>(Forecast from PPS)</Text></HeadTable>
          </tr>
        </SubHeader>
        <BodyTable style={{ display: this.state.collapse_overall ? 'none' : '' }}>
          <tr>
            <td>Revenue</td>
            <td>{total_hardwares_price}</td>
            <td>{total_min_hardwares_price}</td>
            <td>{numeral(project_hardware_contract_price).format('0,0.00')}</td>
            {/* <td>
              <NumberField
                name='project_hardware_contract_price'
                disabled={ true }
                value={ project_hardware_contract_price }
                thousandSeparator={ true }
                allowEmptyFormatting={ true }
                decimalScale={ 2 }
                fixedDecimalScale={ true }
                onBlur={ (e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  this.handleInput(e)
                } }
                onKeyDown={ async (e) => {
                  if (e.keyCode === 13) {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    await this.handleInput(e)
                    this.props.clickCalculate(this.state)
                  }
                } }
              />
            </td> */}
            <td>{`${total_hardwares_discount_price} (${fallbackNanOrInfinity(total_hardwares_discount_ratio)} %)`}</td>
            <td>{total_change_requests_hardware_price}</td>
            <td>
              {financialFormatter(total_pps_hardwares_price)}
            </td>
            <td>
              {financialFormatter(total_pps_hardwares_price_submit)}
            </td>
          </tr>
          <tr>
            <td>Total Cost</td>
            <td>{total_hardwares_cost}</td>
            <td>{total_hardwares_cost}</td>
            <td>{total_hardwares_cost}</td>
            <td>-</td>
            <td>{total_change_requests_hardware_cost}</td>
            <td>{total_pps_hardwares_cost}</td>
            <td>{total_pps_hardwares_cost_submit}</td>
          </tr>
          <tr>
            <td>Gross Profit</td>
            <td>{total_max_hardwares_gross_profit}</td>
            <td>{total_min_hardwares_gross_profit}</td>
            <td>{total_hardwares_gross_profit}</td>
            <td>-</td>
            <td>{total_change_requests_hardware_gross_profit}</td>
            <td>{total_pps_hardwares_gross_profit}</td>
            <td>{total_pps_hardwares_gross_profit_submit}</td>
          </tr>
          <tr>
            <td>Gross Profit Ratio</td>
            <td>{fallbackNanOrInfinity(decimalFormatter(total_max_hardwares_gross_profit_ratio))} %</td>
            <td>
              <NumberPerField
                name='project_hardware_ratio_minimum'
                disabled={!get(this.props, 'editBreakDown')}
                value={decimalFormatter(project_hardware_ratio_minimum)}
                thousandSeparator={true}
                allowEmptyFormatting={true}
                decimalScale={2}
                fixedDecimalScale={true}
                onBlur={(e) => {
                  e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                  this.handleInput(e)
                }}
                onKeyDown={async (e) => {
                  if (e.keyCode === 13) {
                    e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                    await this.handleInput(e)
                    this.props.clickCalculate(this.state)
                  }
                }}
              />%
            </td>
            <td>
              {fallbackNanOrInfinity(decimalFormatter(total_hardwares_gross_profit_ratio))} %
            </td>
            <td>-</td>
            <td>{fallbackNanOrInfinity(total_change_requests_hardware_gross_profit_ratio)} %</td>
            <td>
              {fallbackNanOrInfinity(decimalFormatter(total_pps_hardwares_gross_profit_ratio))} %
            </td>
            <td>
              {fallbackNanOrInfinity(decimalFormatter(total_pps_hardwares_gross_profit_ratio_submit))} %
            </td>
          </tr>
        </BodyTable>

      </CustomTable>
    )
  }
}

IndividualRevenueTable.propTypes = {
  clickEdit: PropTypes.func,
  cancelEdit: PropTypes.func,
  clickCalculate: PropTypes.func,
  editBreakDownRevenues: PropTypes.func,
}
IndividualRevenueTable.defaultProps = {
  clickEdit: () => { },
  cancelEdit: () => { },
  clickCalculate: () => { },
  editBreakDownRevenues: () => { },
}

const CustomTable = styled(Table)`
  background: white;
  th {
    border: none;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
  thead {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM};
    font-size: ${FONTS.SMALL_SIZE};
    border-bottom: 1px solid #CCCCCC;
  } tbody tr {
    display:table;
    width:100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody td {
    font-family: 'NotoSans' !important;
    font-variant-numeric: tabular-nums;
    -moz-font-feature-settings: "tnum";
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    border: none ;
    text-align:right;
    justify-content: flex-end;
  } thead th {
    font-family: ${FONTS.GOTHAM_MEDIUM};
    font-size: ${FONTS.SMALL_SIZE};
    border: none ;
    text-align:right;
    justify-content: flex-end;
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 225px);
  overflow-y:scroll;
  background-color: #F9F9F9;
  border-bottom: 1px solid #CCCCCC !important;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`
const Text = styled.p`
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: 10px ;
  margin-bottom: 0px;
`
const Icon = styled.img`
  width : 10px ;
  height : 10px;
  margin-left: 1%;
  margin-right: 1%;
  cursor: pointer;
`
const SubHeader = styled.thead`
  background: white;
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM};
`
const Header = styled.thead`
  height: 50px;
  background: #404040;
  color: white;
  display: flex !important;
  align-items: center;
  cursor: pointer;
`
const HeaderEdit = styled.thead`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 50px;
  background: white;
  color: black;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  border-bottom: 1px solid #CCCCCC;
`

const HeaderWrapper = styled.th`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`

const NumberField = styled(NumberFormat)`
  font-family: 'NotoSans' !important;
  font-variant-numeric: tabular-nums;
  -moz-font-feature-settings: "tnum";
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  text-align:right;
  width : 90% ;
  font-size: 14px ;
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
    const status = props.disabled
    if (status === !get(this.props, 'editBreakDown')) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`
const NumberPerField = styled(NumberFormat)`
  font-family: 'NotoSans' !important;
  font-variant-numeric: tabular-nums;
  -moz-font-feature-settings: "tnum";
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  text-align:right;
  width : 90% ;
  font-size: 14px ;
  border-radius: 5px;
  border: 1px solid #CCCCCC;
  background-color: ${props => {
    const status = props.disabled
    if (status === !get(this.props, 'editBreakDown')) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`
const EditPriceWrapper = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 5px;
  position: relative;

  #tooltip {
    position: absolute;
    left: -330px;
    top: -3px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
  }

  :hover {
  ${p => (p.disabled && `
    #tooltip {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
    `)}
  }
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-overview/table-individual-revenue.js